import React, { Fragment } from 'react'
import NextImage from 'next/image'
import { buildContentfulImageURL } from '@sh24/contentful-service/utils'
import resizeRelative from './resize-relative'

const Image = ({ image, maxWidth, maxHeight, quality = 75, priority = false, responsive = true }) => {
  if (!image) return null
  const { srcWidth, srcHeight } = image
  const { width, height } = resizeRelative({
    srcWidth,
    srcHeight,
    maxHeight,
    maxWidth,
  })

  const styles = {}
  if (responsive) {
    styles.width = '100%'
    styles.height = 'auto'
  }

  const Wrapper = responsive ? 'span' : Fragment

  return (
    <Wrapper>
      <NextImage
        loader={buildContentfulImageURL}
        src={image.src}
        width={width}
        height={height}
        priority={priority}
        quality={quality}
        alt={image.description || ''}
        style={styles}
      />
    </Wrapper>
  )
}

export default Image
